import { Filter } from '../filter/filter.model';
import { Action, ActionType, ConditionRelation } from './collection.model';
import { FilterType } from "../../../../../../api/src/data-source/models/filter.model";

export const defaultLimitOptions = [5, 10, 25];

/**
 * Filters
 */

export const searchFilter: Filter = {
	id: 'search',
	name: $localize `:Table Filter Label@@tableFilterSearchLabel:Search`,
	category: 'overall',
	paramKey: 'query',
	type: FilterType.Search,
	order: 0
};

export const segmentFilter: Filter = {
	id: 'segments',
	name: $localize `:Table Filter Label@@tableFilterSegmentsLabel:Segments`,
	type: FilterType.MultiSelect,
	category: 'overall',
	paramKey: 'segments',
	order: 1,
	globalSettingsOptionsKey: 'segments'
};

export const enrollmentPeriodFilter: Filter = {
	id: 'enrollmentPeriod',
	name: $localize `:Table Filter Label@@tableFilterEnrollment PeriodLabel:Enrollment Period`,
	type: FilterType.SingleSelect,
	category: 'overall',
	paramKey: 'enrollmentPeriod',
	order: 1.2,
	globalSettingsOptionsKey: 'enrollmentPeriods'
};

export const campaignFilter: Filter = {
	id: 'campaigns',
	name: $localize `:Table Filter Label@@tableFilterCampaignsLabel:Campaigns`,
	type: FilterType.MultiSelect,
	category: 'overall',
	paramKey: 'campaigns',
	order: 2,
	globalSettingsOptionsKey: 'campaigns'
};

export const tacticFilter: Filter = {
	id: 'tactics',
	name: $localize `:Table Filter Label@@tableFilterTacticsLabel:Tactics`,
	type: FilterType.MultiSelect,
	category: 'overall',
	paramKey: 'tactics',
	order: 2.1,
	globalSettingsOptionsKey: 'tactics'
};

export const campaignPackageFilter: Filter = {
	id: 'campaignPackages',
	name: $localize `:Table Filter Label@@tableFilterCampaignPackagesLabel:Campaign Packages`,
	type: FilterType.MultiSelect,
	category: 'overall',
	paramKey: 'campaignPackages',
	order: 2.1,
	globalSettingsOptionsKey: 'campaignPackages'
};

export const roleFilter: Filter = {
	id: 'role',
	name: $localize `:Table Filter Label@@tableFilterUsersRolesLabel:Users Roles`,
	type: FilterType.SingleSelect,
	category: 'overall',
	paramKey: 'role',
	order: 2,
	globalSettingsOptionsKey: 'roles'
};

/**
 * Actions
 */

export const getRemoveAction = (): Action => ({
	id: 'remove',
	name: $localize `:Table Action Button Label@@tableActionButtonRemoveLabel:Remove`,
	icon: 'delete',
	classes: 'danger',
	type: ActionType.REMOVE,
	showTooltip: true
});

// Backward compatibility - this will be evaluated at runtime when accessed
export const removeAction: Action = getRemoveAction();

export const reportingAction: Action = {
	id: 'report',
	name: $localize `:Table Action Button Label@@tableActionButtonDetailsLabel:Details`,
	icon: '',
	classes: 'danger',
	type: ActionType.REPORT,
	showTooltip: true
};

export const downloadImportAction: Action = {
	id: 'download',
	name: $localize `:Table Action Button Label@@tableActionButtonDownloadLabel:Download`,
	icon: 'download',
	classes: 'info',
	type: ActionType.DOWNLOAD,
	showTooltip: true
};

export const detailAction: Action = {
	id: 'detail',
	name: $localize `:Table Action Button Label@@tableActionButtonDetailsLabel:Details`,
	icon: 'edit',
	type: ActionType.GO_TO,
	showTooltip: true
};

export const cloneAction: Action = {
	id: 'clone',
	name: $localize `:Table Action Button Label@@tableActionButtonCloneLabel:Clone`,
	icon: 'content_copy',
	methodName: 'clone',
	type: ActionType.CLONE,
	showTooltip: true
};


export const getCopyIdAction = (): Action => ({
	id: 'copyId',
	name: $localize `:Table Action Button Label@@tableActionButtonCopyIdLabel:Copy Id to Clipboard`,
	icon: 'content_paste',
	type: ActionType.COPY_ID,
	showTooltip: true
});

// Backward compatibility
export const copyIdAction: Action = getCopyIdAction();

export const getEditAction = (): Action => ({
	id: 'edit',
	name: $localize `:Table Action Button Label@@tableActionButtonEditLabel:Edit`,
	icon: 'edit',
	methodName: 'edit',
	classes: 'text-rose-red',
	type: ActionType.EDIT,
	showTooltip: true
});

// Backward compatibility
export const editAction: Action = getEditAction();

export const selectAction: Action = {
	id: 'select',
	name: $localize `:Table Action Button Label@@tableActionButtonSelectLabel:Select`,
	// icon: 'uil-square',
	icon: '',
	type: ActionType.SELECT,
	showName: true,
	showTooltip: false,
	toggleOptions: {
		// onIcon: 'uil-check-square',
		onIcon: '',
		onName: 'Selected'
	}
};

export const createAction: Action = {
	id: 'create',
	name: $localize `:Table Action Button Label@@tableActionButtonCreateLabel:Create`,
	icon: '',
	type: ActionType.CREATE,
	showName: true,
	showTooltip: false
};

export const joinAction: Action = {
	id: 'join',
	name: $localize `:Table Action Button Label@@tableActionButtonJoinLabel:Join`,
	icon: 'group_add',
	classes: '',
	type: ActionType.GO_TO,
	showTooltip: true,
	condition: {
		path: 'ui.isMember',
		value: true,
		relation: ConditionRelation.NEQ
	}
};

export const leaveAction: Action = {
	id: 'leave',
	name: $localize `:Table Action Button Label@@tableActionButtonLeaveLabel:Leave`,
	icon: 'group_remove',
	classes: '',
	type: ActionType.GO_TO,
	showTooltip: true,
	condition: {
		path: 'ui.isMember',
		value: true,
		relation: ConditionRelation.EQ
	}
};

export const mergeAction: Action = {
	id: 'merge',
	name: $localize `:Table Action Button Label@@tableActionButtonMergeLabel:Merge`,
	icon: 'merge',
	classes: '',
	type: ActionType.MERGE,
	showTooltip: true
};
export const joinableBusinessAction: Action = {
	id: 'joinableBusiness',
	name: 'Mark as joinable ',
	icon: 'group_add',
	classes: '',
	type: ActionType.IS_JOINABLE,
	showTooltip: true
};

export const toggleAction: Action = {
	id: 'select',
	name: $localize `:Table Action Button Label@@tableActionButtonSelectLabel:Select`,
	icon: 'check_box_outline_blank',
	type: ActionType.SELECT,
	showName: false,
	showTooltip: false,
	toggleOptions: {
		onIcon: 'check_box',
		onName: 'Selected'
	}
};

export const getExportAction = (): Action => ({
	id: 'export',
	name: $localize `:Table Action Button Label@@tableActionButtonExportLabel:Export`,
	icon: 'file_open',
	type: ActionType.EXPORT,
	setLoad: true,
	showName: false,
	showTooltip: false
});

// Backward compatibility - this will be evaluated at runtime when accessed
export const exportAction: Action = getExportAction();

export const menuAction: Action = {
	id: 'menu',
	name: $localize `:Table Action Button Label@@tableActionButtonMenuLabel:Menu`,
	icon: 'more_horiz',
	type: ActionType.MENU,
	showName: false,
	showTooltip: false
};
